export default {"src":"/_next/static/media/jerky.9af65c58.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};